import { createSlice } from '@reduxjs/toolkit';
import { authApi } from './authApi';
import { RootState } from 'app/store';

// TODO: move all this types into a proper types folder
export interface LoginInformation extends Token {
  refresh_token: Token;
  user: UserLoginInformation;
}
interface Token {
  token: string;
  expires: number;
  expires_in?: number;
}
export interface UserLoginInformation {
  id: number;
  name: string | null;
  email: string;
  role: string;
}
interface AuthState {
  accessToken?: Token;
  refreshToken?: Token;
  user?: UserLoginInformation;
  isSalesforceCanvas: boolean;
  salesforceBaseUrl: string;
}

const accessToken = localStorage.getItem('accessToken')
  ? ({ token: localStorage.getItem('accessToken'), expires: 100000 } as Token)
  : undefined;

// TODO: Define a better structure for this daa, according if we are going to keep login after register

const initialState: AuthState = {
  user: undefined,
  accessToken,
  refreshToken: undefined,
  isSalesforceCanvas: false,
  salesforceBaseUrl: '',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, accessToken, refreshToken } = action.payload;
      state.user = user;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
    },
    setRefreshToken: (state, action) => {
      const { refresh_token, user, token, expires } = action.payload.data;
      state.refreshToken = refresh_token;
      state.user = user;
      state.accessToken = { token, expires };
    },
    setSalesforceBaseUrl: (state, action) => {
      const { salesforceBaseUrl } = action.payload;
      state.salesforceBaseUrl = salesforceBaseUrl;
    },
    logout: state => {
      localStorage.clear();
      state.accessToken = undefined;
      state.user = undefined;
      state.refreshToken = undefined;
    },
    setUserInfo: (state, action) => {
      const { user } = action.payload;
      state.user = user;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(authApi.endpoints.authExchange.matchFulfilled, (state, { payload }) => {
      state.user = payload.user;
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;
      state.isSalesforceCanvas = true;
    });
  },
});

export const { setCredentials, logout, setRefreshToken, setUserInfo, setSalesforceBaseUrl } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state: RootState) => state.auth.user;
export const selectIsSalesforceCanvas = (state: RootState) => state.auth.isSalesforceCanvas;
export const selectIsSalesforceUrl = (state: RootState) => state.auth.salesforceBaseUrl;
